import { render, staticRenderFns } from "./qs2-11.vue?vue&type=template&id=72e4a0e7&scoped=true&"
import script from "./qs2-11.vue?vue&type=script&lang=js&"
export * from "./qs2-11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4a0e7",
  null
  
)

export default component.exports